import React from "react";

interface HistoryOrderPoint {
  statusAfter?: string;
}

interface EstimatePointFormatterProps {
  historyOrderPoint: HistoryOrderPoint[];
  page: string;
}

export const EstimatePointFormatter: React.FC<EstimatePointFormatterProps> = ({
  historyOrderPoint,
  page,
}) => {
  const lastStatus =
    page === "main"
      ? historyOrderPoint[0]?.statusAfter
      : historyOrderPoint.slice(-1)[0]?.statusAfter;

  const result = lastStatus && lastStatus !== "APPROVE" ? "≈" : null;

  return <span>{result}</span>;
};
